import { css, useTheme } from '@emotion/react';
import { GetAssetAvatarListData } from '~/types/assetStoreApi';

interface CharactersProps {
  data: GetAssetAvatarListData[];
  handleAvatarClick: (id: string) => void;
  selectedId?: string;
}

export default function Characters({
  data,
  handleAvatarClick,
  selectedId,
}: CharactersProps) {
  const theme = useTheme();

  return (
    <div
      css={css`
        display: flex;
        position: absolute;
        z-index: 1;
        bottom: ${theme.layout.section_side};
        left: ${theme.layout.section_side};
        align-items: center;
        gap: 8px;

        & > button {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 44px;
          height: 44px;
          border-radius: 16px;
          background: ${theme.backgroundColor.bg_light_1};
        }
      `}
    >
      {data.map((el) => {
        const selected = el.id === selectedId;

        return (
          <div
            key={el.id}
            onClick={() => handleAvatarClick(el.id)}
            css={css`
              width: 44px;
              height: 44px;

              img {
                width: 100%;
                height: 100%;
                border: 1px solid
                  ${selected ? theme.themeColor.main_1 : 'transparent'};
                border-radius: 50%;
              }
            `}
          >
            <img src={el.thumbnail} alt='character' />
          </div>
        );
      })}
    </div>
  );
}
